// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/comparison/comparison.component.scss
// module id = 203
// module chunks = 0